import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/components/pages/login/Login.vue';
import Home from '@/components/pages/home/Home.vue';
import LogOperacao from '@/components/pages/logOperacao/LogOperacao.vue';
import NaoAutorizado from '@/components/pages/erro/naoAutorizado/NaoAutorizado.vue';
import Erro404 from '@/components/pages/erro/erro404/Erro404.vue';
import Clientes from '@/components/pages/cadastro/cliente/Clientes.vue';
import NovoCliente from '@/components/pages/cadastro/cliente/NovoCliente.vue';
import ListaClientes from '@/components/pages/cadastro/cliente/ListaClientes.vue';
import EditarCliente from '@/components/pages/cadastro/cliente/EditarCliente.vue';
import ListarPlanos from '@/components/pages/cadastro/plano/ListarPlanos.vue';
import Relatorios from '@/components/pages/relatorios/RelatoriosAdm.vue';
import Cliente from '@/components/pages/relatorios/Cliente.vue';
import Menu from '@/components/pages/cadastro/menu/Menu.vue';
import Planos from '@/components/pages/cadastro/plano/Planos.vue';
import NovoPlano from '@/components/pages/cadastro/plano/NovoPlano.vue';
import Revendedor from '@/components/pages/cadastro/revenda/Revendedor.vue';
import LocksProcesso from '@/components/pages/locks/LocksProcesso.vue';
import AutorizacaoSuporte from '@/components/pages/autorizacaoSuporte/AutorizacaoSuporte.vue';
import LogsManutencaoPonto from '@/components/pages/monitoramento/LogsManutencaoPonto.vue';
import Mensagem from '@/components/pages/cadastro/mensagem/Mensagem.vue';
import Dashboard from '@/components/pages/dashboard/Dashboard.vue';
import ClientesIKAcesso from '@/components/pages/cadastro/cliente/ikacesso/Clientes.vue';
import CadastroClienteIKAcesso from '@/components/pages/cadastro/cliente/ikacesso/CadastroCliente.vue';
import PlanosIKAcesso from '../../components/pages/cadastro/cliente/ikacesso/Planos.vue';
import LogsUsuariosOperacoes from '../../components/pages/cadastro/cliente/ikacesso/LogsUsuariosOperacoes.vue';	
import LosOperadoresOperacoes from '../../components/pages/cadastro/cliente/ikacesso/LosOperadoresOperacoes.vue';
import UsuariosIKAcesso from '../../components/pages/cadastro/cliente/ikacesso/Usuarios.vue';
import GerenciamentoRelogiosTarefas from '@/components/pages/gerenciamento/GerenciamentoRelogiosTarefas.vue';
import LimpezaPonto from '@/components/pages/gerenciamento/LimpezaPonto.vue';

import store from '@/plugins/store/store';

Vue.use(Router);

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			component: Home,
			meta: {
				loginRequerido: true,
				permissao: 0				
			},
			children: [
				{
					path: '/dashboard',
					component: Dashboard,
					meta: {
						loginRequerido: true,
						permissao: 99999		
					},
					children: []
				},
				{
					path: '/cadastro/clientes/ikponto',
					component: Clientes,
					meta: {
						loginRequerido: true,
						permissao: 99999		
					},
					children: [
						{path: '', component: ListaClientes, meta: {loginRequerido: true, permissao: 99999}},
						{path: 'novo', component: NovoCliente, meta: {loginRequerido: true, permissao: 99999}},
						{path: ':id/editar', component: EditarCliente, props: true, meta: {loginRequerido: true, permissao: 99999}}
					]
				},
				{
					path: '/cadastro/clientes/ikacesso',
					component: ClientesIKAcesso,
					meta: {
						loginRequerido: true,
						permissao: 99999		
					}
				},
				{
					path: '/cadastro/clientes/ikacesso/novo',
					component: CadastroClienteIKAcesso,
					meta: {
						loginRequerido: true,
						permissao: 99999		
					}
				},
				{
					path: '/cadastro/clientes/ikacesso/:id/:clienteId/editar',
					component: CadastroClienteIKAcesso,
					props: true,
					meta: {
						loginRequerido: true,
						permissao: 99999		
					}
				},
				{
					path: '/cadastro/clientes/ikacesso/planos',
					component: PlanosIKAcesso,
					meta: { loginRequerido: true, permissao: 99999	},

				},
				{
					path: '/cadastro/clientes/ikacesso/logs-usuarios-operacoes',
					component: LogsUsuariosOperacoes,
					meta: { loginRequerido: true, permissao: 99999	},

				},
				{
					path: '/cadastro/clientes/ikacesso/usuarios',
					component: UsuariosIKAcesso,
					meta: { loginRequerido: true, permissao: 99999	},

				},
				{
					path: '/cadastro/clientes/ikacesso/logs-operadores-operacoes/:idConta/logs',
					component: LosOperadoresOperacoes,
					meta: { loginRequerido: true, permissao: 99999	},

				},
				{
					path: '/cadastro/planos',
					component: Planos,
					meta: {
						loginRequerido: true,
						permissao: 99999		
					},
					children: [
						{path: '', component: ListarPlanos, meta: {loginRequerido: true, permissao: 99999}},
						{path: 'novo', component: NovoPlano, meta: {loginRequerido: true, permissao: 99999}},
						{path: ':id/editar', component: NovoPlano, props: true, meta: {loginRequerido: true, permissao: 99999}}
					]
				},
				{
					path: '/cadastro/menu',
					component: Menu,
					meta: {
						loginRequerido: true,
						permissao: 99999		
					},					
				},
				{
					path: '/cadastro/revendedor',
					component: Revendedor,
					meta: {
						loginRequerido: true,
						permissao: 99999		
					},					
				},
				{
					path: '/cadastro/mensagem',
					component: Mensagem,
					meta: {
						loginRequerido: true,
						permissao: 99999		
					},					
				},
				{
					path: '/relatorios',
					component: Relatorios,
					meta: {
						loginRequerido: true,
						permissao: 99999
					},
					children: [						
						{path: 'clientes', component: Cliente, meta: {loginRequerido: true, permissao: 99999}},						
					]  
				},
				{
					path: '/logs-operacoes',
					component: LogOperacao,
					meta: {
						loginRequerido: true,
						permissao: 99999
					},
				},
				{
					path: '/autorizacao-suporte',
					component: AutorizacaoSuporte,
					meta: {
						loginRequerido: true,
						permissao: 99999
					},
				},
				{
					path: '/logs-manutencao-ponto',
					component: LogsManutencaoPonto,
					meta: {
						loginRequerido: true,
						permissao: 99999
					},
				},
				{
					path: '/gerenciamento-relogios-tarefas',
					component: GerenciamentoRelogiosTarefas,
					meta: {
						loginRequerido: true,
						permissao: 99999
					},
				},
				{
					path: '/limpeza-ponto',
					component: LimpezaPonto,
					meta: {
						loginRequerido: true,
						permissao: 99999
					},
				},
				{
					path: '/locks-processos',
					component: LocksProcesso,
					meta: {
						loginRequerido: true,
						permissao: 99999
					},
				},
			]        
		},		
		{			
			path: '/login',
			component: Login,
			meta: {
				loginRequerido: false,				
			}             
		},
		{
			path: '*',
			component: Erro404
		},
		{			
			path: '/nao-autorizado',
			component: NaoAutorizado,
			meta: {
				loginRequerido: false,				
			}             
		}	
	],
	scrollBehavior() {
		return {x: 0, y: 0};
	}
});

router.beforeEach((to, from, next) => {		
	window.urlAtiva = to.path;
	let isAutenticado = store.getters['sessao/getIsAutenticado'];
	if(to.matched.some(record => record.meta.loginRequerido)) {	
		let permissoes = store.getters['sessao/getPermissoes'];		
		if(!isAutenticado) {	
			next({
				path: '/login',
				query: { redirect: to.fullPath }
			});	
		} else if(permissoes.includes(to.meta.permissao)){		
			next();				
		} else {
			next({
				path: '/nao-autorizado',
				query: { redirect: to.fullPath }
			});	
		}
	} else if(isAutenticado && to.path == '/login') {			
		next('/');
	} else {	
		next();
	}
});

export default router;
